import { useEffect, useState } from 'react';

/**
 * The current time, as state: read when the component mounts and again every
 * `everyMs`. A render that compared against `Date.now()` directly would give
 * a different answer each time it ran.
 */
export function useNow(everyMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), everyMs);
    return () => clearInterval(timer);
  }, [everyMs]);
  return now;
}
